import React from 'react';
import LogoSlide from './logoSlide';
import logoImage1 from '../../../images/wfmuNew.svg';
import logoImage2 from '../../../images/MichealsNew.svg';
import logoImage3 from '../../../images/WalmartNew.svg';
import logoImage4 from '../../../images/PoliticoNew.svg';
import logoImage5 from '../../../images/DreamworksNew.svg';
import logoImage6 from '../../../images/sonyNew.svg';
import logoImage7 from '../../../images/tissotNew.svg';
import logoImage8 from '../../../images/ConverseNew.svg';
import logoImage9 from '../../../images/RaybanNew.svg';

const LogoSlider = ({}) => {
  const logoImage = [
    logoImage1,
    logoImage2,
    logoImage3,
    logoImage4,
    logoImage5,
    logoImage6,
    logoImage7,
    logoImage8,
    logoImage9,
    logoImage1,
    logoImage2,
    logoImage3,
    logoImage4,
    logoImage5,
    logoImage6,
    logoImage7,
    logoImage8,
    logoImage9,
  ];

  return (
    <>
      <section className='logo-slider overflow-x-hidden sm:overflow-x-auto'>
        <div className='border-b border-gray-300'>
          <div className='slider'>
            <div className='slide-track'>
              {logoImage.map((imgSrc, index) => (
                <div className='slide' key={index}>
                  <LogoSlide imgSrc={imgSrc} alt={`logo-${index}`} />
                </div>
              ))}
            </div>
          </div>
          {/* <div className='slider-container overflow-x-hidden'>
            <Slider {...settings}>
              {logoImage.map((imgSrc, index) => (
                <div key={index}>
                  <LogoSlide imgSrc={imgSrc} alt={`logo-${index}`} />
                </div>
              ))}
            </Slider>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default LogoSlider;
